import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';

/*
  Generated class for the FilteringProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class FilteringProvider {

  constructor(public http: HttpClient) {
  }

  async filterByPopover(filterObj, startingArray) {
    let filterByType;
    let filter: {location?: any, ages?:any, eventType?:any, time?:any, date?:any} = {};
    for (var key in filterObj) {
      if (filterObj[key].length > 0 || filterObj[key].lower) filter[key] = filterObj[key];
    }
    // console.log(filterObj, startingArray, filter);
    filterByType = startingArray.filter((event) => {
      for (var key in filter) {
        switch (key) {
          // case ("date"):
          //   let eventDate = moment(event.eventStart);
          //   if (eventDate.isBefore(filter.date.lower, 'day') || eventDate.isAfter(filter.date.upper, 'day')) return false
          // break;
          case ("time"):
            // let eventTime ={hour: moment(event.eventStart).hour(), minute: moment(event.eventStart).minute() }
            let eventTime = moment(event.eventStart);
            let filterTimeLower = moment(event.eventStart).hour(filter.time.lower.hour).minute(filter.time.lower.minute);
            let filterTimeUpper = moment(event.eventStart).hour(filter.time.upper.hour).minute(filter.time.upper.minute);
            // if (Number(eventTime) > Number(filter.time.upper) || Number(eventTime) < Number(filter.time.lower)) {
            //   return false
            // }
            if (eventTime.isBefore(filterTimeLower) || eventTime.isAfter(filterTimeUpper)) return false
            break;
          case ("location"):
            if (!filter.location.includes(event.locationId.toString())) {
              return false
            }
            break;
          case ("ages"):
            let falseCountAges = 0;
            if (event.ages){
              event.ages.forEach(age => {
                if (!filter.ages.includes(age)) {
                  falseCountAges++;
                };
              });
              if (falseCountAges === event.ages.length) {
                return false;
              };
            } else {
              return false;
            }
            break;
          case ("eventType"):
            let falseCountType = 0;
            if (event.types){
              event.types.forEach(eventType => {
                if (!filter.eventType.includes(eventType)) {
                  falseCountType++;
                };
              });
              if (falseCountType === event.types.length) {
                return false;
              };
            } else {
              return false;
            }
            break;
          case ("keyword"):
            let description = (event.description && event.description.length > 0) ? event.description.toLowerCase() : "";
            let shortDesc = (event.shortDescription && event.shortDescription.length > 0) ? event.shortDescription.toLowerCase() : "";
            let title = event.title.toLowerCase();
            let searchTags = "";
            if (event.searchTags && event.searchTags.length > 0) {
              searchTags = event.searchTags.reduce((sum, next) => {
                sum += next.toLowerCase();
                return sum;
              });
            };
            if (description.indexOf(filterObj.keyword) === -1 && shortDesc.indexOf(filterObj.keyword) === -1 && title.indexOf(filterObj.keyword) === -1 && searchTags.indexOf(filterObj.keyword) === -1) {
              return false;
            }
            break;
        }
      }
      return true;
    });
    return filterByType;
  }

  async filterRooms(filterObj, startingArray) {
    let filterByType;
    var filter = filterObj
    filterByType = startingArray.filter((room, i) => {
      for (var key in filter) {
        switch (key) {
          case ("time"):
            // console.log('the filter', this.innerCards[i])
            // if (!this.innerCards[i].timelineArrayForFilterCheck[filter.time.upper * 4] || !this.innerCards[i].timelineArrayForFilterCheck[filter.time.lower * 4]){
            //   return false
            // }
            break;
          case ("location"):
            if (!filter.location.includes(room.locationId.toString())) {
              return false
            }
            break;
          case ("keyword"):
            let roomName = (room.name && room.name.length > 0) ? room.name.toLowerCase() : "";
            let roomTitle = (room.title && room.title.length > 0) ? room.title.toLowerCase() : "";

            if (roomName.indexOf(filterObj.keyword) === -1 && roomTitle.indexOf(filterObj.keyword) === -1) {
              return false;
            }
            break;
        }
      }
      return true;
    });
    return filterByType;
  }

}



// WEBPACK FOOTER //
// ./src/providers/filtering/filtering.ts